export default __webpack_public_path__ + "static/media/7minfitness@2x.b9d43292.jpg";